import React, { Component } from 'react';
import classes from './HeroHead.module.scss';
import articlesJSON from 'data/articles.json';
import ClientLogo from 'components/App/ClientLogo/ClientLogo';
const globalImages = require.context('images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);

class HeroHead extends Component {

    constructor(props){

        super();
        this.props = props;
        this.content = props.content
    
    }

    


    render(){
        return (
            <div  className={classes['heroHead']}>
                <div className={classes['heroHead__footer']}>
                    <div className={classes['heroHead__title']}>
                        <div className={`text_subtitle_wrapper`}>
                            <p className={`text_subtitle ${classes.similarArticles__Subtitle}`}>{articlesJSON.text.title}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default HeroHead;